import React, { ComponentProps, Ref } from 'react';
import { Flex } from '@chakra-ui/react';

type FlexProps = ComponentProps<typeof Flex>;

type Props = FlexProps & {
  contentContainerProps?: FlexProps;
  outerRef?: Ref<HTMLDivElement>;
};

export function ScrollPane(props: Props) {
  let { contentContainerProps, outerRef, children, ...otherProps } = props;
  return (
    <Flex
      direction="column"
      flex="1 1 0%"
      maxH="100%"
      overflowY="auto"
      ref={outerRef}
      {...otherProps}
    >
      <Flex direction="column" {...contentContainerProps}>
        {children}
      </Flex>
    </Flex>
  );
}
